export default {"src":"/_next/static/media/error-image.06858312.svg","height":138,"width":138,"blurWidth":0,"blurHeight":0};